import { VerticalLayout } from "./layout";

export function TitleInput({ title, closed, description, typeInput, value, placeholder, onChange, disabled }) {
  const handleTelChange = (e) => {
    if (typeInput === "tel") {
      const newValue = e.target.value.replace(/[^0-9]/g, '');
      onChange({ target: { value: newValue } });
    } else {
      onChange(e);
    }
  };

  return (
    <div className="horizontal standard-margin no-center">
      <VerticalLayout style={{ width: "13rem" }}>
        <p className="xsmall-text grey-900 bold-text title-input-title">{title}</p>
        {description && <p className="xsmall-text grey-600">{description}</p>}
      </VerticalLayout>
      <div className="horizontal phone-textarea" style={{ width: "unset" }}>
        {typeInput === "area" ? (
          <textarea
            className={`standard-input setting-input ${closed && "no-left-radius"}`}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            disabled={disabled}
          />
        ) : (
          <input
            className={`standard-input setting-input ${closed && "no-left-radius"}`}
            type={typeInput || "text"}
            placeholder={placeholder}
            value={value}
            onChange={handleTelChange}
            disabled={disabled}
          />
        )}
      </div>
    </div>
  );
}
